import './index.css'

import React, { Component } from 'react'
import Resume from '../form/resume'
import ResumeOptions from '../form/resume-options'
import Spinner from '../../components/utils/spinner'
import MyContentLoader from '../../components/utils/content-loader'
import { Link } from 'react-router-dom'

import axios from 'axios'
import { nanoid } from 'nanoid'

import Scrollbar from 'react-smooth-scrollbar'

class EditComponent extends Component {
  constructor(props) {
    super(props)

    let resumeData = JSON.parse(localStorage.getItem('resumeData'))

    if (resumeData !== null) {
      if (resumeData.hash.length > 0 && resumeData.psw.length) {
        this.state = {
          resume: {},
          hash: resumeData.hash,
          psw: resumeData.psw,
          token: resumeData.token,
          dataCompleted: false,
          saving: false,
          preview: null,
          error: false,
        }
      }
    }
  }

  getMaxHeight = () => {
    return window.innerHeight * 0.94
  }

  update = (field, data) => {
    let resume = this.state.resume

    if (field === 'showExperience') {
      resume.skill.showExperience = data
    } else if (field === 'skill') {
      resume.skill.list = data
    } else {
      resume[field] = data
    }

    this.setState({ resume })
  }

  updateHeaders = (field, data) => {
    let resume = this.state.resume
    resume.headers[field] = data
    this.setState({ resume })
  }

  componentDidMount = () => {
    if (this.state) {
      this.fetchData()
    } else {
      this.props.history.push('/')
    }
  }

  fetchData = () => {
    clearInterval(this.refreshTimeID)

    let options = { headers: {} }

    if (this.state.psw !== null) {
      options.headers.psw = this.state.psw
    } else {
      options.headers.authorization = this.state.token
    }

    axios
      .get(`${process.env.REACT_APP_API_URL}/resume/${this.state.hash}/edit`, options)
      .then(response => {
        let resume = response.data.resume

        this.setState({ error: false, dataCompleted: true, resume: this.generateKeys(resume) })
      })
      .catch(err => {
        this.setState({ error: true, dataCompleted: false })
        this.props.history.push('/')
      })
  }

  saveResume = () => {
    clearInterval(this.refreshTimeID)

    let options = { headers: { preview: true }, responseType: 'blob' }

    if (this.state.psw !== null) {
      options.headers.psw = this.state.psw
    } else {
      options.headers.authorization = this.state.token
    }

    this.setState({ saving: true, error: false })

    axios
      .patch(
        `${process.env.REACT_APP_API_URL}/resume/${this.state.hash}/edit`,
        { content: this.state.resume },
        options,
      )
      .then(response => {
        let imgUrl = URL.createObjectURL(response.data)

        this.setState({ saving: false, preview: imgUrl, error: false })
      })
      .catch(err => {
        this.setState({ saving: false, error: true })
      })
  }

  generateKeys = resume => {
    const defaultHeaders = {
      summary: '',
      education: '',
      work: '',
      link: '',
      language: '',
      skill: '',
      course: '',
      project: '',
    }

    let newResume = {
      name: resume.name,
      lang: resume.lang,
      basics: resume.basics,
      skill: { showExperience: resume.skill.showExperience, list: [] },
    }

    newResume.headers = { ...defaultHeaders, ...resume.headers }

    newResume.education = resume.education.map(element => {
      element.key = nanoid()
      return element
    })

    newResume.work = resume.work.map(element => {
      element.key = nanoid()
      return element
    })

    newResume.link = resume.link.map(element => {
      element.key = nanoid()
      return element
    })

    newResume.language = resume.language.map(element => {
      element.key = nanoid()
      return element
    })

    newResume.skill.list = resume.skill.list.map(element => {
      element.key = nanoid()
      return element
    })

    newResume.course = resume.course.map(element => {
      element.key = nanoid()
      return element
    })

    newResume.project = resume.project.map(element => {
      element.key = nanoid()
      return element
    })

    return newResume
  }

  showResumePreview = () => {
    if (this.state.preview) {
      return <img src={this.state.preview} alt="" />
    }

    return (
      <MyContentLoader
        style={{ backgroundColor: 'white', borderRadius: '4px', width: '80%', maxWidth: '800px' }}
      />
    )
  }

  showForm = () => {
    let maxHeight = this.getMaxHeight()

    return (
      <React.Fragment>
        <Scrollbar
          style={{
            maxWidth: '960px',
            maxHeight: maxHeight + 'px',
            width: '50%',
            padding: '20px 40px',
          }}
        >
          <div className="share-link-edit-page" style={{}}>
            <Link to="/share">
              Go to Share Page to see the link and number of views and downloads.
            </Link>
            <span
              title="Save this data to edit the Resume in the future"
              style={{ fontSize: '15px' }}
            >
              Resume <b>{this.state.hash}</b> & Password <b>{this.state.psw}</b>
            </span>
          </div>

          <Resume
            name={this.state.resume.name}
            lang={this.state.resume.lang}
            basics={this.state.resume.basics}
            education={this.state.resume.education}
            work={this.state.resume.work}
            link={this.state.resume.link}
            language={this.state.resume.language}
            skill={this.state.resume.skill.list}
            showExperience={this.state.resume.skill.showExperience}
            course={this.state.resume.course}
            project={this.state.resume.project}
            headers={this.state.resume.headers}
            update={this.update}
            updateHeaders={this.updateHeaders}
          />

          <div style={{ height: '30px' }}></div>
        </Scrollbar>

        <Scrollbar
          style={{
            maxWidth: '960px',
            maxHeight: maxHeight + 'px',
            padding: '20px 40px',
            width: '50%',
            backgroundColor: 'rgb(122,133,153)',
          }}
        >
          <ResumeOptions
            saving={this.state.saving}
            error={this.state.error}
            hash={this.state.hash}
            saveResume={this.saveResume}
          />

          <div className="resume-preview">
            <div className="resume-preview-img">{this.showResumePreview()}</div>
          </div>
        </Scrollbar>
      </React.Fragment>
    )
  }

  render() {
    if (this.state && this.state.dataCompleted) {
      return this.showForm()
    } else {
      return <Spinner />
    }
  }
}

export default EditComponent
